// ContactParticle.js
import React from "react";
import Particles from "react-tsparticles";

function ContactParticle() {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 0, // background layer
        top: 0,
        left: 0,
        pointerEvents: "none", // prevents it from blocking form input
      }}
    >
      <Particles
        id="contact-particles"
        options={{
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                area: 800,
              },
            },
            move: {
              direction: "none",
              speed: 0.2,
            },
            size: {
              value: 2,
            },
            opacity: {
              value: 0.3,
            },
            line_linked: {
              enable: true,
              distance: 150,
              opacity: 0.1,
            },
          },
          interactivity: {
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
            },
            modes: {
              repulse: {
                distance: 100,
              },
            },
          },
          retina_detect: true,
        }}
      />
    </div>
  );
}

export default ContactParticle;
